export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'
export const TOGGLE_EDIT_OVERLAY = 'TOGGLE_EDIT_OVERLAY'
export const SET_ROLES = 'SET_ROLES'
export const SET_ROLE_NAME = 'SET_ROLE_NAME'
export const SET_ROLE_LEVEL = 'SET_ROLE_LEVEL'
export const SET_CURRENT_ROLE = 'SET_CURRENT_ROLE'
export const SET_CURRENT_ROLE_NAME = 'SET_CURRENT_ROLE_NAME'
export const SET_CURRENT_ROLE_LEVEL = 'SET_CURRENT_ROLE_LEVEL'
export const DELETE_CURRENT_ROLE = 'DELETE_CURRENT_ROLE'
export const SET_ROLES_LOADING = 'SET_ROLES_LOADING'
export const SET_SEARCH_VALUE_ON_CLICK = 'SET_SEARCH_VALUE_ON_CLICK'
